import { makeStyles } from 'tss-react/mui';

const useStylesChartFunnel: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  containerChartFunnel: {
    height: 300,
  },
}));

export default useStylesChartFunnel;
